import { render, staticRenderFns } from "./PnlPivotTable.vue?vue&type=template&id=2be0eae3&scoped=true"
import script from "./PnlPivotTable.vue?vue&type=script&lang=js"
export * from "./PnlPivotTable.vue?vue&type=script&lang=js"
import style0 from "./PnlPivotTable.vue?vue&type=style&index=0&id=2be0eae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0eae3",
  null
  
)

export default component.exports